/* eslint-disable jsx-a11y/media-has-caption -- Device recordings are silent; reduced steps describe the journey. */
import { useEffect, useState } from 'react';
import { Alert, Spin, Typography } from 'antd';
import { E2EMedia } from '../../../domain/models/E2ERun';
import getE2EMedia, { GetE2EMediaPayload } from '../../../domain/use_cases/e2e/getE2EMedia';
import E2EStatus from './E2EStatus';

export default function E2EMediaPlayer({
  runKey,
  runAttempt,
  media,
}: {
  runKey: string;
  runAttempt: number;
  media: E2EMedia;
}) {
  const [state, setState] = useState({ key: '', url: '', error: '' });
  const key = `${runKey}:${runAttempt}:${media.id}:${media.availability}`;
  const url = state.key === key ? state.url : '';
  const error = state.key === key ? state.error : '';
  useEffect(() => {
    let cancelled = false;
    let objectUrl = '';
    if (media.availability === 'available')
      getE2EMedia(new GetE2EMediaPayload(runKey, runAttempt, media.id))
        .then((blob) => {
          if (cancelled) return;
          objectUrl = URL.createObjectURL(blob);
          setState({ key, url: objectUrl, error: '' });
        })
        .catch((error) => {
          if (!cancelled) setState({ key, url: '', error: error.message ?? 'Média indisponible' });
        });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [runKey, runAttempt, media.id, media.availability, key]);
  return (
    <div style={{ marginTop: 12 }}>
      <Typography.Paragraph>
        {media.kind === 'video' ? 'Vidéo' : 'Capture'} · <E2EStatus status={media.availability} />
        {media.expiresAt && `Expire le ${new Date(media.expiresAt).toLocaleDateString()}`}
      </Typography.Paragraph>
      {media.redaction !== 'complete' && (
        <Alert
          type="warning"
          message="Ce média peut contenir des données non masquées. Accès réservé au staff."
          showIcon
          style={{ marginBottom: 12 }}
        />
      )}
      {/* Device screen recordings are silent; the reduced steps above describe the journey. */}
      {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
      {error ? (
        <Alert type="error" message={error} showIcon />
      ) : (
        media.availability === 'available' &&
        (url ? (
          media.kind === 'video' ? (
            <video
              aria-label="Vidéo du parcours E2E"
              controls
              preload="metadata"
              src={url}
              style={{ maxWidth: '100%', maxHeight: 520 }}
            />
          ) : (
            <img
              src={url}
              alt="Capture du parcours E2E"
              style={{ maxWidth: '100%', maxHeight: 520, objectFit: 'contain' }}
            />
          )
        ) : (
          <Spin />
        ))
      )}
    </div>
  );
}
